import Icon from '@material-ui/icons/Receipt';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../../controllers';
import { NumberField, TextField } from '../../../../fields';
import { BooleanInput, NestedReferenceInput, TextInput } from '../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="amount"
        />
        <TextInput
          source="description"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ invoice_id: props.parentResource.id }}
        {...props}
      >
        <NestedReferenceInput
          filter={{status: 'new'}}
          resourcePath={`/${props.parentResource.parentResource.resource}/${props.parentResource.parentResource.id}`}
          source="subscription_id"
        />
        <TextInput
          source="amount"
          required
        />
        <TextInput
          source="description"
          required
        />
        <BooleanInput
          source="refundable"
          defaultValue
          disabled
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="id"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <NumberField
          source="amount"
        />
        <TextField
          source="description"
        />
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
